import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        openClass: { type: String, default: 'show-ws24-menu' },
        headlineOverlayClass: { type: String, default: 'show-ws24-headline-overlay'}
    }

    toggle() {
        document.body.classList.toggle(this.openClassValue);

        if (document.body.classList.contains(this.openClassValue)) {
            window.scrollTo({top: 0, behavior: 'smooth'});
            document.body.classList.remove(this.headlineOverlayClassValue);
        }
    }

    toggleHeadline() {
        document.body.classList.toggle(this.headlineOverlayClassValue);
    }

    open() {
        document.body.classList.add(this.openClassValue);
        document.body.classList.remove(this.headlineOverlayClassValue);
    }

    close() {
        document.body.classList.remove(this.openClassValue);
    }
}
